export default __webpack_public_path__ + "static/media/address.35992695.svg";